
import axios from "axios";
import { styleFactory } from "@geos-consult/gimage-viewer";

const CONFIG_KEY = "https://etropublic01.blob.core.windows.net/etro-json/full/";

const buildImageParams = (width = 0, height = 0) =>
{
  let params = {
    q: "auto",
    f: "auto",
  };

  if (width > 0)
  {
    params.w = width;
  }

  if (height > 0)
  {
    params.h = height;
  }

  const imageParams = Object.entries(params)
    .map(([key, value]) => `${key}_${value}`)
    .join(",");

  return `${imageParams}/`;
};

export const getImageUrl = async (style, color = null, width = 0, height = 0) =>
{
  const defaultColor = "NOCOLOR";
  const getBestImage = styleFactory(CONFIG_KEY);

  const bestImageResult = await getBestImage({
    style: style,
    color: color ?? defaultColor,
  });

  const bestImage = bestImageResult;

  if (bestImage)
  {
    return bestImage.urlPrefix + buildImageParams(width, height) + bestImage.publicId;
  }

  return null;
};

export const getImageUrls = async (id, colorId, width = 0, height = 0) =>
{
  const response = await axios.get(
    `${CONFIG_KEY}${id}.json`
  );

  const imageUrls = response?.data
    ?.filter(item => item?.color === colorId)
    .map(item => item.urlPrefix + buildImageParams(width, height) + item.publicId);

  return imageUrls ?? [];
};

export const validateImageUrl = async (url, width, height) =>
{
  let path = url.replace("{transf}/", buildImageParams(width, height));
  return await axios
    .get(path)
    .then(() =>
    {
      return path;
    })
    .catch(() =>
    {
      return false;
    });
};
